import { CommonModule } from '@angular/common';
import { Component, input, output } from '@angular/core';

@Component({
  selector: 'app-admin-toggle-switch',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './admin-toggle-switch.component.html',
  styleUrl: './admin-toggle-switch.component.scss',
})
export class AdminToggleSwitchComponent {
  checked = input(false);
  disabled = input(false);
  ariaLabel = input<string | null>(null);

  checkedChange = output<boolean>();

  toggle(): void {
    if (this.disabled()) {
      return;
    }
    this.checkedChange.emit(!this.checked());
  }
}
